(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-video-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const storageKey = 'winkyProductVideoClosed';

  const getClosedState = () => {
    try {
      return sessionStorage.getItem(storageKey) === 'true';
    } catch {
      return false;
    }
  };

  const setClosedState = (closed) => {
    try {
      sessionStorage.setItem(storageKey, closed ? 'true' : 'false');
    } catch {
      return;
    }
  };

  const createPlayer = (container) => {
    if (!container || getClosedState()) return;
    const existingPlayer = container.querySelector('iframe');
    if (existingPlayer) {
      if (existingPlayer.dataset.videoSrc) {
        existingPlayer.src = existingPlayer.dataset.videoSrc;
      }
      return;
    }
    const videoId = container.dataset.videoId;
    if (!/^[A-Za-z0-9_-]{6,20}$/.test(videoId)) return;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&playsinline=1&rel=0`;
    iframe.title = container.getAttribute('aria-label');
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';
    container.append(iframe);
  };

  const destroyPlayer = (container) => {
    const iframe = container?.querySelector('iframe');
    if (!iframe) return;
    iframe.dataset.videoSrc = iframe.src;
    iframe.src = 'about:blank';
  };

  const clampPosition = (container, left, top) => {
    const safe = 8;
    const maxLeft = Math.max(safe, window.innerWidth - container.offsetWidth - safe);
    const maxTop = Math.max(safe, window.innerHeight - container.offsetHeight - safe);
    return {
      left: Math.min(Math.max(safe, left), maxLeft),
      top: Math.min(Math.max(safe, top), maxTop),
    };
  };

  const initializeDrag = (container) => {
    const handle = container.querySelector('[data-product-video-drag]');
    if (!handle) return;
    let dragState = null;

    handle.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button, a')) return;
      const rect = container.getBoundingClientRect();
      dragState = {
        pointerId: event.pointerId,
        offsetX: event.clientX - rect.left,
        offsetY: event.clientY - rect.top,
      };
      handle.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    handle.addEventListener('pointermove', (event) => {
      if (!dragState || dragState.pointerId !== event.pointerId) return;
      const position = clampPosition(
        container,
        event.clientX - dragState.offsetX,
        event.clientY - dragState.offsetY,
      );
      container.style.right = 'auto';
      container.style.bottom = 'auto';
      container.style.left = `${position.left}px`;
      container.style.top = `${position.top}px`;
    });

    handle.addEventListener('pointerup', (event) => {
      if (!dragState || dragState.pointerId !== event.pointerId) return;
      dragState = null;
      handle.releasePointerCapture(event.pointerId);
    });
  };

  const initialize = () => {
    document.querySelectorAll('[data-product-video]').forEach((container) => {
      const reopen = container.nextElementSibling;
      document.body.append(container);
      if (reopen?.matches('[data-product-video-reopen]')) {
        document.body.append(reopen);
      }
      const close = container.querySelector('[data-product-video-close]');
      const wasClosed = getClosedState();
      container.hidden = wasClosed;
      if (reopen?.matches('[data-product-video-reopen]')) reopen.hidden = !wasClosed;

      close?.addEventListener('click', (event) => {
        event.stopPropagation();
        destroyPlayer(container);
        container.hidden = true;
        if (reopen) reopen.hidden = false;
        setClosedState(true);
      });

      reopen?.addEventListener('click', () => {
        setClosedState(false);
        container.removeAttribute('style');
        container.hidden = false;
        reopen.hidden = true;
        createPlayer(container);
      });

      initializeDrag(container);

      const schedulePlayer = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(() => createPlayer(container), { timeout: 2400 });
        } else {
          window.setTimeout(() => createPlayer(container), 1600);
        }
      };

      if (document.readyState === 'complete') {
        schedulePlayer();
      } else {
        window.addEventListener('load', schedulePlayer, { once: true });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
